const prefetchedRouteKeys = new Set();
const pendingRouteKeys = new Set();

export const isPrefetchConnectionAllowed = (connection) => {
  if (!connection) return true;
  if (connection.saveData === true) return false;

  const effectiveType = String(connection.effectiveType || '').toLowerCase();
  return effectiveType !== 'slow-2g' && effectiveType !== '2g';
};

const getBrowserConnection = () => {
  if (typeof navigator === 'undefined') return null;
  return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
};

export const prefetchRouteOnIntent = async ({ routeKey, load, connection = getBrowserConnection() }) => {
  if (!routeKey || typeof load !== 'function') return false;
  if (!isPrefetchConnectionAllowed(connection)) return false;
  if (prefetchedRouteKeys.has(routeKey) || pendingRouteKeys.has(routeKey)) return false;

  pendingRouteKeys.add(routeKey);
  try {
    await load();
    prefetchedRouteKeys.add(routeKey);
    return true;
  } catch {
    return false;
  } finally {
    pendingRouteKeys.delete(routeKey);
  }
};

export const resetRoutePrefetchStateForTests = () => {
  prefetchedRouteKeys.clear();
  pendingRouteKeys.clear();
};
